export default function ValidateUserDataPricing(form, noPLnumber) {
  let error = {};

  if (!form.name) {
    error.name = "Proszę wpisać swoje imię.";
  } else if (form.name.length < 3) {
    error.name = "Proszę wpisać poprawne imię.";
  }

  if (!form.email) {
    error.email = "Proszę wpisać swój adres e-mail.";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(form.email)) {
    error.email = "Proszę wpisać poprawny adres e-mail.";
  }

  // if (noPLnumber && !form.email) {
  //   error.email = "Proszę wpisać swój adres e-mail.";
  // } else if (noPLnumber && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(form.email)) {
  //   error.email = "Proszę wpisać poprawny adres e-mail.";
  // }

  if (!form.phone) {
    error.phone = "Proszę wpisać swój numer telefonu.";
  } else if (!/(^|\W)(\(?(\+|00)?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)/g.test(form.phone)) {
    error.phone = "Proszę wpisać poprawny numer telefonu.";
  }

  // if (!noPLnumber && !form.phone) {
  //   error.phone = "Proszę wpisać swój numer telefonu.";
  // } else if (!noPLnumber && !/(^|\W)(\(?(\+|00)?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)/g.test(form.phone)) {
  //   error.phone = "Proszę wpisać poprawny numer telefonu.";
  // }

  return error;
};